import barba from '@barba/core';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { MotionPathPlugin } from "gsap/MotionPathPlugin";
import lottie from "lottie-web";

gsap.registerPlugin(MotionPathPlugin);



let stInstance;

function servicesList()
{
    // Desktop version of the animations
    const desktopServicesAnimationElement = document.querySelector('#desktopServicesAnimationTrigger');

    if (desktopServicesAnimationElement != null)
    {
        const animationJSON = desktopServicesAnimationElement.dataset.servicesListAnimation;
        const animationContainer = document.getElementById('desktopServicesAnimationWindow');

        if (animationContainer.hasChildNodes())
        {
            while (animationContainer.firstChild)
            {
                animationContainer.removeChild(animationContainer.lastChild);
            }
        }

        LottieScrollTrigger({
            trigger: "#desktopServicesAnimationTrigger",
            target: "#desktopServicesAnimationWindow",
            path: animationJSON,
            start: "top center",
            end: "bottom center",
            pin: false,
            renderer: "svg",
            markers: false,
            rendererSettings: {
                preserveAspectRatio: "xMidYMid meet"
            },
            scrub: 0.5
        });
    }


    // Mobile versions
    const serviceListItems = document.querySelectorAll('.servicesList__item');

    if (serviceListItems.length > 0)
    {
        [...serviceListItems].forEach((element, index) => {
            const animationJSON = element.dataset.servicesListItemAnimation;
    
            LottieScrollTrigger({
                trigger: element,
                target: element.querySelector('.servicesList__item-icon'),
                path: animationJSON,
                start: "30% bottom",
                end: "30% center",
                pin: false,
                renderer: "svg",
                markers: false,
                rendererSettings: {
                    preserveAspectRatio: "xMidYMid meet"
                },
                scrub: 0.5
            });
        });

        // Text Elements
        [...serviceListItems].forEach((element, index) => {
            const servicesListItem__contentElement = element.querySelector('.servicesList__item-content');
            const servicesListItem__titleElement = element.querySelector('.servicesList__item-title');
            const servicesListItem__tagsElement = element.querySelector('.servicesList__item-tags');
            const servicesListItem__introductionElement = element.querySelector('.servicesList__item-introduction');
            const servicesListItem__buttonElement = element.querySelector('.servicesList__item-button');

            const servicesListItemTimeline = gsap.timeline(
                {
                    scrollTrigger: 
                    {
                        trigger: element,
                        start: "top bottom",
                        end: "center center",
                        scrub: 0.5,
                        markers: false
                    }
                }
            );

            const itemLayout = index % 2;

            if (itemLayout == 0)
            {
                servicesListItemTimeline.set(servicesListItem__titleElement, { x: "-50%" });
                servicesListItemTimeline.set(servicesListItem__tagsElement, { x: "-30%" });
                servicesListItemTimeline.set(servicesListItem__introductionElement, { x: "-15%" });
                servicesListItemTimeline.set(servicesListItem__buttonElement, { x: "-5%" });
            }
            else
            {
                servicesListItemTimeline.set(servicesListItem__titleElement, { x: "50%" });
                servicesListItemTimeline.set(servicesListItem__tagsElement, { x: "30%" });
                servicesListItemTimeline.set(servicesListItem__introductionElement, { x: "15%" });
                servicesListItemTimeline.set(servicesListItem__buttonElement, { x: "5%" });
            }

            servicesListItemTimeline.set(servicesListItem__contentElement, { opacity: 0 });

            servicesListItemTimeline.to(servicesListItem__contentElement, { opacity: 1, duration: 0.5 });
            servicesListItemTimeline.to(servicesListItem__titleElement, { x: "0%", duration: 0.5 }, "-=0.5");
            servicesListItemTimeline.to(servicesListItem__tagsElement, { x: "0%", duration: 0.5 }, "-=0.5");
            servicesListItemTimeline.to(servicesListItem__introductionElement, { x: "0%", duration: 0.5 }, "-=0.5");
            servicesListItemTimeline.to(servicesListItem__buttonElement, { x: "0%", duration: 0.5 }, "-=0.5");

        });
    }
}

function LottieScrollTrigger(vars)
{
    let playhead = {frame: 0},
        target = gsap.utils.toArray(vars.target)[0],
        speeds = {slow: "+=2000", medium: "+=1000", fast: "+=500"},
        st = {trigger: target, pin: true, start: "top top", end: speeds[vars.speed] || "+=1000", scrub: 1},
        ctx = gsap.context && gsap.context(),
        animation = lottie.loadAnimation({
            container: target,
            renderer: vars.renderer || "svg",
            loop: false,
            autoplay: false,
            path: vars.path,
            rendererSettings: vars.rendererSettings || { preserveAspectRatio: 'xMidYMid slice' }
        });
        for (let p in vars) {
            st[p] = vars[p];
        }
    animation.addEventListener("DOMLoaded", function() {
      let createTween = function() {
         animation.frameTween = gsap.to(playhead, {
            frame: animation.totalFrames - 1,
            ease: "none",
            onUpdate: () => animation.goToAndStop(playhead.frame, true),
            scrollTrigger: st
        });
        return () => animation.destroy && animation.destroy();
      };
      ctx && ctx.add ? ctx.add(createTween) : createTween();
      ScrollTrigger.sort();
      ScrollTrigger.refresh();
    });
    return animation;
}


barba.hooks.enter((data) => {

    servicesList();

});


servicesList();